export default {
  acceptTermsRequired: 'कृपया नियम और शर्तें स्वीकार करें',
  accountNumber: 'खाता संख्या',
  acknowledgeText: 'स्वीकारें',
  acknowledgedText: 'स्वीकार किया',
  active: 'सक्रिय',
  activeBookings: 'सक्रिय बुकिंग',
  activeBucketsText: 'सक्रिय बकेट',
  activeToday: 'आज सक्रिय',
  adminRole: 'एडमिन — प्रबंध निदेशक',
  advance: 'अग्रिम',
  advancePaid: 'अग्रिम भुगतान',
  advancePaidLabel: 'अग्रिम',
  agreeTermsCheckbox: 'मैंने सभी नियम और शर्तें पढ़ी हैं और स्वीकार की हैं',
  agreement: 'नियम और समझौता',
  alertLog: 'अलर्ट लॉग',
  alertText: 'अलर्ट',
  alerts: 'अलर्ट',
  allAlerts: 'सभी चेतावनियाँ',
  allLoaded: 'सभी लोड',
  allMachinesOk: 'सभी मशीनें ठीक चल रही हैं।',
  allStats: 'पूर्ण आंकड़े',
  allowedText: 'अनुमत',
  amount: 'राशि',
  apiHealthTitle: 'API स्वास्थ्य',
  apiSloAlertsTitle: 'API SLO अलर्ट',
  appName: 'डेवलपमेंट एक्सप्रेस',
  approvals: 'अनुमोदन',
  approveAndDispatch: 'स्वीकृत करें और मशीन भेजें',
  approved: 'स्वीकृत',
  assignedOperator: 'नियुक्त ऑपरेटर',
  attemptsLabel: 'प्रयास',
  attendance: 'उपस्थिति',
  auditLogs: 'ऑडिट लॉग्स',
  available: 'उपलब्ध',
  availableMachinery: 'उपलब्ध मशीनरी',
  availableNow: 'अभी उपलब्ध',
  avgRating: 'औसत रेटिंग',
  awaitingClientFeedback: 'क्लाइंट फीडबैक की प्रतीक्षा',
  awaitingDispatch: 'डिस्पैच की प्रतीक्षा',
  back: 'वापस जाएं',
  backToLogin: 'लॉगिन पर वापस जाएं',
  bank: 'बैंक',
  bankDetailsTitle: 'बैंक विवरण',
  baseAmount: 'मूल राशि',
  billingWallet: 'वॉलेट और बिलिंग',
  blacklistWarning: '⛔ ब्लैकलिस्ट चेतावनी',
  blockedRateText: 'ब्लॉक दर',
  blockedText: 'ब्लॉक्ड',
  bookMachine: 'मशीन बुक करव',
  bookMachineAction: 'मशीन बुक करें',
  bookNow: 'अभी बुक करें',
  bookingConfirm: 'बुकिंग पुष्टि करें',
  bookingCostCalculator: 'बुकिंग और लागत कैलकुलेटर',
  bookingFailedGeneric: 'बुकिंग विफल। पुनः प्रयास करें।',
  bookingHistory: 'बुकिंग इतिहास',
  bookingReportTitle: 'बुकिंग रिपोर्ट',
  bookingScheduleSummary: 'दिन और महीने अनुसार बुकिंग शेड्यूल',
  bookingSelectMachineFirst: 'जारी रखने के लिए फ्लीट से मशीन चुनें।',
  bookingStepChoose: 'मशीन चुनें',
  bookingStepConfirm: 'पुष्टि और भुगतान',
  bookingStepCost: 'लागत और तारीख',
  bookingType: 'बुकिंग प्रकार चुनें',
  bookingTypeLabel: 'बुकिंग प्रकार',
  bookingTypeText: 'बुकिंग प्रकार',
  bookingsCount: '{count} बुकिंग',
  bookingsScheduleHint: 'क्लाइंट बुकिंग करने पर दिनवार शेड्यूल यहाँ दिखेगा।',
  burstText: 'बर्स्ट',
  busy: 'व्यस्त',
  callNow: 'अभी कॉल करें',
  cancel: 'रद्द करें',
  cancelAction: 'रद्द करें',
  cancelBooking: 'बुकिंग रद्द करें',
  cancelBookingPrompt: 'बुकिंग रद्द करें?',
  cancelPolicy: 'रद्दीकरण नीति',
  cancelText: 'रद्द',
  cancelWarning: 'क्या आप रद्द करना चाहते हैं?',
  changeLanguage: 'भाषा बदलव',
  changeMachine: 'मशीन बदलें',
  changeMobileNumber: 'Change mobile number',
  chipAction: 'क्रिया',
  chipActor: 'कर्ता',
  chipEntity: 'एंटिटी',
  chipFrom: 'से',
  chipMeta: 'मेटा',
  chipRole: 'भूमिका',
  chipTo: 'तक',
  clearAll: 'सभी साफ करें',
  client: 'ग्राहक',
  clientFeedbackLabel: 'क्लाइंट फीडबैक',
  clientPortal: 'क्लाइंट पोर्टल',
  clientRatingsTitle: 'क्लाइंट रेटिंग और सुझाव',
  clientRole: 'क्लाइंट (ठेकेदार)',
  clients: 'ग्राहक',
  commission: 'कमीशन',
  commission15: 'कमीशन 15%',
  commissionPaid: 'कमीशन भुगतान',
  commissionRate: 'सकल बिलिंग का 15%',
  company: 'कंपनी',
  companyDetailsTitle: 'कंपनी विवरण',
  completeBookings: 'पूर्ण बुकिंग',
  completedBookings: 'पूर्ण बुकिंग',
  condition: 'स्थिति',
  confirm: 'पुष्टि करव',
  confirmBooking: 'बुकिंग पुष्टि करें',
  confirmBookingAction: 'बुकिंग की पुष्टि करें',
  confirmCancel: 'रद्दीकरण पुष्टि करें',
  confirmPassword: 'Confirm password',
  confirmRetry: 'पुनः प्रयास की पुष्टि करें',
  contactCompany: 'डेवलपमेंट एक्सप्रेस से संपर्क करें',
  costCalculator: 'लागत कैलकुलेटर',
  crawlerNoRto: 'क्रॉलर (RTO नहीं)',
  currentlyDeployed: 'वर्तमान में तैनात',
  customAmount: 'कस्टम राशि (UPI/कार्ड ₹1 से)',
  cycles: "चक्र",
  dailyWorkReport: 'दैनिक कार्य रिपोर्ट',
  dashboard: 'डैशबोर्ड',
  date: 'दिनांक',
  dayMachinesLabel: 'मशीनें',
  days: 'दिन',
  daysUnit: 'दिन',
  directContactBlacklist: 'सीधा संपर्क = ब्लैकलिस्ट',
  directContactProhibited: 'सीधा संपर्क सख्त वर्जित',
  directContactProhibitedText: 'सीधा संपर्क सख्त प्रतिबंधित',
  dispatched: 'भेजा गया',
  dlqMonitor: 'DLQ मॉनिटर',
  docChassisPlate: 'चेसिस / सीरियल प्लेट फोटो (RTO RC नहीं)',
  docEquipmentPhoto: 'पूर्ण मशीन फोटो (साइड व्यू)',
  docIdentity: 'PAN / आधार',
  docInsurance: 'बीमा प्रमाणपत्र',
  docInsuranceOptional: 'बीमा / उपकरण कवर (यदि उपलब्ध)',
  docMachineInvoice: 'मशीन खरीद / इनवॉइस',
  docPollution: 'प्रदूषण प्रमाणपत्र (PUC)',
  docRcBook: 'RC बुक (RTO पंजीकरण प्रमाणपत्र)',
  documentUploadTitle: 'दस्तावेज़ अपलोड',
  documents: 'दस्तावेज़ अपलोड',
  download: 'डाउनलोड',
  drawerMenu: 'मेनू',
  earnings: 'कमाई',
  email: 'ईमेल सहायता',
  emailAddress: 'ईमेल पता',
  emailAddressLabel: 'ईमेल पता',
  expandBookingHint: 'पूरी बुकिंग, रद्द करें और ऑपरेटर रेटिंग के लिए नीचे महीना/दिन सेक्शन expand करें।',
  experience: 'अनुभव',
  exportCsv: 'CSV एक्सपोर्ट',
  failedText: 'असफल',
  feedbackAfterDispatch: 'मशीन डिस्पैच के बाद ऑपरेटर रेटिंग उपलब्ध होगी।',
  feedbackStatusAfterDispatch: 'डिस्पैच के बाद',
  feedbackStatusRateNow: 'ऑपरेटर रेट करें ↓',
  filterAll: 'सभी',
  filterCredit: 'क्रेडिट',
  filterDebit: 'डेबिट',
  filterCompleted: 'पूर्ण',
  filterCancelled: 'बंद',
  filterPending: 'लंबित',
  filterDisputed: 'विवादित',
  forgotPasswordChooseMethod: 'Choose email link or SMS OTP to reset your password.',
  forgotPasswordEmailDevHint: 'Local dev: open the API server terminal and copy the “Password reset link (development)” URL.',
  forgotPasswordEmailHint: 'Enter your registered admin email address.',
  forgotPasswordFailed: 'Could not send reset link. Please try again.',
  forgotPasswordIntro: 'We will email a secure reset link to your registered email address.',
  forgotPasswordInvalidEmail: 'Please enter a valid email address.',
  forgotPasswordInvalidOtp: 'Enter the 6-digit OTP from SMS.',
  forgotPasswordInvalidPhone: 'Please enter a valid 10-digit mobile number.',
  forgotPasswordLink: 'Forgot password?',
  forgotPasswordOtpSentTo: 'OTP sent to',
  forgotPasswordPhoneHint: 'Enter your registered mobile number. Reset link goes to the email on your account.',
  forgotPasswordSendOtp: 'Send OTP',
  forgotPasswordSending: 'Sending...',
  forgotPasswordSendingOtp: 'Sending OTP...',
  forgotPasswordSmsDevHint: 'SMS not configured in production yet — in development, check server logs for the OTP code.',
  forgotPasswordSmsFailed: 'Could not send OTP. Please try again.',
  forgotPasswordSmsHint: 'Enter your registered mobile number. A 6-digit OTP will be sent by SMS.',
  forgotPasswordSmsSuccess: 'If an account exists, OTP was sent to the registered mobile number.',
  forgotPasswordSubmit: 'Send reset link',
  forgotPasswordSuccess: 'If an account exists, reset instructions were sent to the registered email.',
  forgotPasswordTitle: 'Reset your password',
  formLabel: 'फॉर्म',
  fuel: 'ईंधन',
  fuelColon: 'ईंधन:',
  fuelHistoryTitle: 'ईंधन इतिहास',
  fuelLevel: 'ईंधन स्तर',
  fuelLevelUpdate: 'फ्यूल स्तर अपडेट',
  fuelNotePlaceholder: 'नोट: भरा / उपयोग ईंधन...',
  fullName: 'पूरा नाम',
  goBook: '→ मशीन बुक करें',
  gpsLiveLabel: '🟢 GPS लाइव',
  grandTotal: 'कुल योग',
  grandTotalText: 'कुल योग',
  gross: 'सकल',
  grossBilling: 'सकल बिलिंग',
  gst18: 'GST (18%)',
  gstInvoice: 'GST इनवॉइस',
  gstInvoices: 'GST इनवॉइस',
  gstin: 'GSTIN',
  hide: 'छुपाएं',
  highTrend: 'HIGH ट्रेंड',
  hitsText: 'हिट्स',
  hmrHrs: 'घंटे',
  hmrToday: 'आज का HMR',
  hmrTotal: 'कुल HMR',
  home: 'होम',
  hours: 'घंटे',
  hrsUnit: 'घंटे',
  idle: 'निष्क्रिय',
  ifsc: 'IFSC',
  ignition: 'इग्निशन',
  importantInfo: 'मशीन मालिकों के लिए महत्वपूर्ण जानकारी',
  instantCost: 'त्वरित लागत कैलकुलेटर',
  invoiceNotAvailableCancelled: 'इनवॉइस उपलब्ध नहीं (रद्द)',
  iot: 'IoT और GPS',
  issueReportTitle: 'समस्या रिपोर्ट',
  issueReportedSuccess: 'इश्यू यशस्वीरित्या नोंदवला!',
  issues: 'समस्याएं',
  joinUsAction: 'Join Us — मुफ्त रजिस्टर करें',
  joinUsBanner: 'मशीन किराए पर चाहिए?',
  joinUsHint: 'नए ग्राहक? JCB, excavator, crane बुक करने के लिए मुफ्त रजिस्टर करें।',
  landingCtaApp: 'Development Express खोलें',
  landingFeatBook: 'मिनटों में बुकिंग',
  landingFeatBookDesc: 'JCB, excavator, crane — live availability.',
  landingFeatPay: 'Wallet payments',
  landingFeatPayDesc: 'GST invoice, transparent billing.',
  landingFeatTrack: 'Live GPS',
  landingFeatTrackDesc: 'हर घंटे machine location पता करें।',
  landingHeroLine1: 'Smarter & Simpler.',
  landingHeroLine2: 'महाराष्ट्र का smart machinery rental.',
  landingSocialProof: 'महाराष्ट्र भर के builders और contractors जुड़े हैं।',
  landingStatMachines: 'मशीनें',
  landingStatRating: 'रेटिंग',
  landingTrustLine: 'Wallet-only · GST · Secured',
  lastRefreshed: 'अंतिम रिफ्रेश',
  live: 'लाइव',
  liveBookAvail: 'बुकिंग के बाद लाइव फीड उपलब्ध',
  liveCamera: '360° लाइव कैमरा — बुकिंग के बाद',
  liveMachineLocation: 'लाइव मशीन स्थान',
  liveText: 'लाइव',
  liveTracking: 'लाइव ट्रैकिंग',
  loadMoreAlerts: 'और अलर्ट लोड करें',
  loadMoreAttendance: 'और उपस्थिति लोड करें',
  loadMoreBookings: 'और बुकिंग लोड करें',
  loadMoreDlq: 'और DLQ लोड करें',
  loadMoreFuelLogs: 'और फ्यूल लॉग लोड करें',
  loadMoreLogs: 'और लॉग लोड करें',
  loadMoreMachines: 'और मशीनें लोड करें',
  loadMoreTransactions: 'और ट्रांजैक्शन लोड करें',
  loadMoreUsers: 'और यूजर्स लोड करें',
  loadedBookings: 'लोड की गई बुकिंग',
  loadedDlqItems: 'लोडेड DLQ आइटम',
  loadedFuelLogs: 'लोड किए गए फ्यूल लॉग',
  loadedOwnerBookings: '{count} मालिक बुकिंग लोड{suffix}',
  loading: 'लोड हो रहा है...',
  loadingDashboard: 'डैशबोर्ड लोड हो रहा है...',
  location: 'स्थान',
  lockConfirm: '🔒 लॉक पुष्टि करें',
  lockMachine: 'मशीन लॉक करें',
  lockWarning: 'Teltonika GPS के जरिए मशीन का इग्निशन दूर से बंद हो जाएगा।',
  locked: 'लॉक',
  loginAs: 'लॉगिन हो रहे हैं',
  loginChangeRole: 'भूमिका बदलें',
  loginClientPortalSubtitle: 'निर्माण मशीनरी बुक करने के लिए साइन इन करें',
  loginEmailHint: 'एडमिन लॉगिन के लिए रजिस्टर्ड ईमेल इस्तेमाल करें।',
  loginFailedGeneric: 'लॉगिन असफल — कृपया फिर से प्रयास करें',
  loginIAmQuestion: 'मैं कौन…?',
  loginModeOtp: 'OTP लॉगिन',
  loginModePassword: 'पासवर्ड',
  loginNewHereRegister: 'नए हैं? रजिस्टर करें',
  loginOtpDevHint: 'Development: SMS न हो तो server log में OTP देखें।',
  loginOtpHint: 'रजिस्टर्ड मोबाइल पर 6 अंकों का OTP भेजा जाएगा।',
  loginOtpSentTo: 'OTP भेजा:',
  loginOwnerPortalSubtitle: 'अपनी फ्लीट और पंजीकरण प्रबंधित करने के लिए साइन इन करें',
  loginPhoneHint: 'क्लाइंट, ओनर और ऑपरेटर लॉगिन के लिए रजिस्टर्ड मोबाइल नंबर इस्तेमाल करें।',
  loginPickRoleHint: 'पंजीकृत? भूमिका चुनें। नए हैं? नीचे Join Us।',
  loginPortalAdminSubtitle: 'प्लेटफ़ॉर्म नियंत्रण और अनुमोदन',
  loginPortalAdminTitle: 'एडमिन पोर्टल',
  loginPortalClientSubtitle: 'निर्माण मशीनरी बुक करने के लिए साइन इन',
  loginPortalClientTitle: 'क्लाइंट पोर्टल',
  loginPortalOperatorSubtitle: 'नियुक्त मशीन और दैनिक लॉग के लिए साइन इन',
  loginPortalOperatorTitle: 'ऑपरेटर पोर्टल',
  loginPortalOwnerSubtitle: 'फ्लीट और पंजीकरण प्रबंधित करने के लिए साइन इन',
  loginPortalOwnerTitle: 'मालिक पोर्टल',
  loginRoleAdminDesc: 'प्लेटफ़ॉर्म नियंत्रण, अनुमोदन और संचालन',
  loginRoleClientDesc: 'निर्माण परियोजनाओं के लिए मशीनरी बुक करें',
  loginRoleClientShort: 'क्लाइंट',
  loginRoleOperatorDesc: 'नियुक्त मशीन और दैनिक लॉग',
  loginRoleOwnerDesc: 'फ्लीट, कमाई और उपलब्धता प्रबंधित करें',
  loginRoleOwnerShort: 'ओनर',
  loginSendOtp: 'OTP भेजें',
  loginSendingOtp: 'OTP भेज रहे हैं...',
  loginSignInShort: 'साइन इन',
  loginTabOtp: 'OTP',
  loginTabPassword: 'पासवर्ड',
  loginVerifyOtp: 'Verify करें',
  loginVerifyingOtp: 'Verify हो रहा है...',
  logout: 'लॉगआउट',
  sessionRevokedAlert: 'तुमन दूसर डिवाइस म लॉग इन हौ। कृपया फेर लॉगिन करव।',
  machine: 'मशीन',
  machineDefaultLabel: 'मशीन',
  machineDetails: 'मशीन और ऑपरेटर विवरण',
  machineDetailsTitle: 'मशीन विवरण',
  machineDispatchedAt: 'मशीन भेजी गई — {when}',
  machineHours: 'मशीन घंटे',
  machineIdLabel: 'मशीन ID',
  machineInfo: 'मशीन की जानकारी',
  machineLabel: 'मशीन',
  machineLog: 'मशीन लॉग',
  machineReg: 'मशीन पंजीकरण फॉर्म',
  machineRegistrationSubmitted: 'मशीन नोंदणी सबमिट झाली! DE टीम 24 तासांत पडताळणी करेल.',
  machineRegistrationTitle: 'मशीन पंजीकरण',
  machineStatus: 'मशीन स्थिति',
  machineStatusTitle: 'मशीन स्थिति',
  machines: 'मशीनें',
  marketingBackHome: 'वेबसाइट होम',
  marketingBadge: 'लाइव ऑपरेशन · कराड, सातारा',
  marketingBuiltFor: 'सटीकता, अनुपालन और गति चाहने वाली भारतीय निर्माण टीमों के लिए।',
  marketingCtaBook: 'मशीन बुक करें',
  marketingCtaLogin: 'Development Express खोलें — लॉगिन',
  marketingCtaWhatsApp: 'WhatsApp करें',
  marketingFooterRights: '2026 डेवलपमेंट एक्सप्रेस · कराड, सातारा',
  marketingHeadline: 'महाराष्ट्र का अग्रणी मशीनरी रेंटल प्लेटफॉर्म',
  marketingLead: 'रीयल-टाइम GPS, डिजिटल वॉलेट भुगतान, और निर्माण मशीनरी के लिए स्वचालित संचालन। 2011 से सेवा में।',
  marketingNavContact: 'संपर्क',
  marketingNavLogin: 'प्लेटफॉर्म लॉगिन →',
  marketingNavServices: 'सेवाएँ',
  marketingNavTech: 'प्रौद्योगिकी',
  marketingServicesTitle: 'हम क्या देते हैं',
  marketingStatDigital: 'डिजिटल भुगतान',
  marketingStatFleet: 'लाइव मशीनें',
  marketingStatYears: 'वर्षों का अनुभव',
  marketingSvcOps: 'पूर्ण संचालन सूट',
  marketingSvcOpsSub: 'मालिक, ऑपरेटर, क्लाइंट — एक प्लेटफॉर्म।',
  marketingSvcPay: 'केवल वॉलेट निपटान',
  marketingSvcPaySub: 'GST इनवॉइस — साइट पर नकद नहीं।',
  marketingSvcTrack: 'GPS और लाइव स्थिति',
  marketingSvcTrackSub: 'Teltonika से जुड़ी फ्लीट दृश्यता।',
  marketingTechLead: 'Development Express बुकिंग, अनुपालन और फील्ड टेलीमेट्री को एक ही वर्कफ़्लो में जोड़ता है।',
  md: 'MD',
  mediumTrend: 'MEDIUM ट्रेंड',
  minAdvanceRequired: 'न्यूनतम अग्रिम आवश्यक',
  minimumAdvance: 'न्यूनतम अग्रिम आवश्यक',
  minimumRecharge: 'UPI/कार्ड/QR के लिए न्यूनतम ₹1।',
  moUnit: 'महीने',
  mobileNumber: 'मोबाइल नंबर',
  monthMachineSummary: 'इस महीने की मशीनें',
  monthTotalLabel: 'महीने का कुल',
  months: 'महीने',
  moreAvailable: 'और उपलब्ध',
  myBookings: 'हमर बुकिंग',
  myClientRating: 'मेरी क्लाइंट रेटिंग',
  myMachines: 'मेरी मशीनें',
  neftRtgs: 'NEFT/RTGS',
  netEarnedMonth: 'नेट कमाई (माह)',
  netPaid: 'नेट भुगतान',
  netPayable: 'शुद्ध देय',
  netReceived: 'नेट प्राप्त',
  netReceivedCaps: 'नेट प्राप्त',
  neverText: 'कभी नहीं',
  newBooking: 'नई बुकिंग',
  newClientRegister: 'नया क्लाइंट? यहां रजिस्टर करें',
  newClientRegistration: 'नया क्लाइंट पंजीकरण',
  newPassword: 'New password',
  nextText: 'आगे',
  noAlerts: 'कोई अलर्ट नहीं!',
  noAlertsNow: 'अभी कोई अलर्ट नहीं।',
  noBankRefund: '❌ बैंक रिफंड नहीं — केवल वॉलेट क्रेडिट',
  noBookings: 'कोई सक्रिय बुकिंग नहीं',
  noBookingsAccount: 'इस खाते के लिए अभी तक कोई बुकिंग नहीं।',
  noBookingsYet: 'अभी तक कोई बुकिंग नहीं',
  noClientFeedbackYet: 'अभी कोई क्लाइंट रेटिंग नहीं। डिस्पैच के बाद क्लाइंट फीडबैक यहाँ दिखेगा।',
  noDlqItems: 'कोई DLQ आइटम नहीं',
  noFileSelected: 'कोई फ़ाइल नहीं',
  noMachinesDashboard: 'अभी कोई मशीन नहीं। फ्लीट जोड़ने के लिए मशीन पंजीकरण करें।',
  noMachinesTrack: 'ट्रैक करने के लिए कोई मशीन नहीं',
  noMachinesTrackHint: 'GPS ट्रैकिंग के लिए मशीन पंजीकृत करें।',
  noMachinesYet: 'अभी कोई मशीन पंजीकृत नहीं',
  noMoreAuditLogs: 'वर्तमान फिल्टर के लिए और ऑडिट लॉग नहीं मिले।',
  noRecentApiSloBreach: 'हाल में कोई API SLO breach संकेत नहीं।',
  noRecentFailedLogins: 'हाल में कोई असफल लॉगिन प्रयास नहीं।',
  noRefund: 'नो रिफंड नीति',
  noSecuritySignalsFound: 'कोई सुरक्षा संकेत नहीं मिले।',
  noTransactionsFilter: 'चयनित फ़िल्टर के लिए कोई लेनदेन नहीं।',
  normalText: 'सामान्य',
  off: 'बंद',
  officeLabel: 'ऑफिस',
  on: 'चालू',
  operator: 'ऑपरेटर',
  operatorFeedbackColumn: 'ऑपरेटर फीडबैक',
  operatorFeedbackSaved: 'धन्यवाद! आपका फीडबैक सेव हो गया।',
  operatorFeedbackSubmitted: 'आपका फीडबैक',
  operatorFeedbackTitle: 'ऑपरेटर फीडबैक',
  operatorPortal: 'ऑपरेटर पोर्टल',
  operatorRole: 'ऑपरेटर',
  operatorSatisfactionQuestion: 'क्या आप ऑपरेटर से संतुष्ट हैं?',
  operatorSuggestionPlaceholder: 'सुझाव या फीडबैक (वैकल्पिक)',
  operators: 'ऑपरेटर',
  optionalLabel: '(वैकल्पिक)',
  otpCode: 'OTP code',
  overview: 'अवलोकन',
  ownerBookingsAllLoaded: ' (सभी लोड)',
  ownerBookingsMoreAvailable: ' (और उपलब्ध)',
  ownerInfo: 'मालिक की जानकारी',
  ownerPortal: 'मालिक पोर्टल',
  ownerRole: 'मशीन मालिक',
  owners: 'मालिक',
  password: 'पासवर्ड',
  passwordsMustMatch: 'Password and confirm password must match.',
  pastIssuesTitle: 'पिछली समस्याएं',
  payNow: 'अभी भुगतान करें',
  payNowText: 'अभी भुगतान करें',
  paymentBreakdownTitle: 'भुगतान विवरण — अप्रैल 2026',
  paymentCycle: 'भुगतान चक्र',
  paymentFailed: 'पेमेंट अयशस्वी! कृपया पुन्हा प्रयत्न करा.',
  paymentHistory: 'भुगतान इतिहास',
  paymentHistoryTitle: 'भुगतान इतिहास',
  paymentMethods: 'भुगतान के तरीके',
  paymentMode: 'भुगतान मोड',
  paymentSuccess: 'पेमेंट यशस्वी!',
  pdfInvoiceFailed: 'इनवॉइस PDF नहीं बन सका। पुनः प्रयास करें।',
  pdfReportFailed: 'रिपोर्ट PDF नहीं बन सका। पुनः प्रयास करें।',
  pdiCompleted: '✅ PDI / सुरक्षा निरीक्षण पूर्ण',
  pdiCrawlerHint: 'क्रॉलर: प्रदूषण (PUC) आवश्यक नहीं — RTO पंजीकृत नहीं।',
  pdiInfo: 'PDI निरीक्षण',
  pdiInsuranceApplicable: '✅ बीमा / कवर (यदि लागू)',
  pdiInsuranceValid: '✅ बीमा वैध और अद्यतन',
  pdiPollutionValid: '✅ प्रदूषण प्रमाणपत्र (PUC) वैध',
  pdiTitle: 'प्री-डिलीवरी निरीक्षण (PDI)',
  penaltyDeduct: 'रद्दीकरण दंड (1 घंटा)',
  pending: 'लंबित',
  pendingApproval: 'स्वीकृति लंबित',
  pendingCount: '{count} लंबित',
  pendingDispatch: 'डिस्पैच प्रतीक्षेत',
  perDay: 'प्रति दिन',
  perHour: 'प्रति घंटा',
  perMonth: 'प्रति माह',
  perWeek: 'प्रति सप्ताह',
  phone: 'फ़ोन',
  platform: 'निर्माण प्रबंधन मंच',
  platformAgreement: 'प्लेटफॉर्म समझौता',
  policyLabel: 'नीति',
  policyTopicBooking: 'बुकिंग',
  policyTopicCancellation: 'रद्दीकरण',
  policyTopicContact: 'संपर्क',
  policyTopicGst: 'GST',
  policyTopicHours: 'सपोर्ट समय',
  portalBackLink: 'पोर्टल',
  portalClient: 'क्लाइंट',
  portalClientSub: 'मशीनरी बुक करें',
  portalNewClientRegister: 'नए क्लाइंट? रजिस्टर करें',
  portalNewOwnerRegister: 'नए ओनर? रजिस्टर करें',
  portalOwner: 'ओनर',
  portalOwnerSub: 'फ्लीट प्रबंधन',
  portalStaffAdmin: 'एडमिन',
  portalStaffOperator: 'ऑपरेटर',
  portalWelcome: 'स्वागत है',
  portalWelcomeHint: 'जारी रखने के लिए अपना पोर्टल चुनें',
  quantityLabel: 'मात्रा',
  quickIssueReport: 'त्वरित समस्या रिपोर्ट',
  quickRechargeUpi: 'UPI से त्वरित रिचार्ज',
  quickSelect: 'त्वरित चयन:',
  rateCard: 'दर पत्रक (ऑपरेटर सहित)',
  rateLimitTelemetryTitle: 'रेट लिमिट टेलीमेट्री',
  rateOperatorWork: 'ऑपरेटर का काम रेट करें (1–5 स्टार)',
  rating: 'रेटिंग',
  receiptId: 'रसीद ID',
  recentAlerts: 'हाल की चेतावनियाँ',
  recentFailedLoginsTitle: 'हाल की असफल लॉगिन',
  recentLabel: 'हाल का',
  recharge: 'रिचार्ज',
  rechargeFirst: '⚡ पहले वॉलेट रिचार्ज करें',
  rechargeWallet: '+ वॉलेट रिचार्ज',
  ref: 'संदर्भ संख्या',
  refreshText: 'रिफ्रेश',
  refreshingText: 'रिफ्रेश हो रहा है...',
  regCapacitySpecs: 'क्षमता / विवरण',
  regDocCrawlerHint: 'क्रॉलर: चेसिस प्लेट, खरीद इनवॉइस, फोटो और ID। बीमा वैकल्पिक।',
  regDocWheeledHint: 'व्हील्ड: RC (RTO), बीमा, PUC और ID (अधिकतम 5MB प्रत्येक)।',
  regEquipmentCategory: 'उपकरण श्रेणी *',
  regFailed: 'पंजीकरण विफल। कृपया पुनः प्रयास करें।',
  regFileSizeError: 'प्रत्येक दस्तावेज़ अधिकतम 5MB',
  regFileTypeError: 'केवल PDF, JPG, PNG या WEBP अनुमत',
  regFleetIdOptional: 'फ्लीट / चेसिस ID (वैकल्पिक)',
  regMachineCategory: 'मशीन श्रेणी *',
  regMachineInfoTitle: 'मशीन जानकारी',
  regMachineIntro: 'केवल निर्माण heavy equipment — कोई ट्रक/ट्रांसपोर्ट नहीं। व्हील्ड (JCB 3DX) के लिए RTO; क्रॉलर (Poclain) साइट पर — RTO passing नहीं।',
  regMachineNameModel: 'मशीन नाम / मॉडल',
  regMobilityTracked: 'क्रॉलर',
  regMobilityTrackedHint: 'Poclain / chain excavator, dozer — साइट उपकरण, RTO passing नहीं',
  regMobilityWheeled: 'व्हील्ड',
  regMobilityWheeledHint: 'JCB 3DX, wheeled loader, grader — RTO (RC) वाला निर्माण उपकरण',
  machineFinancialSection: 'मशीन खरीद विवरण (वैकल्पिक)',
  machineOwnershipType: 'स्वामित्व प्रकार',
  machineOwnershipNew: 'नई मशीन',
  machineOwnershipUsed: 'मूल मालिक',
  machineOwnershipSecondHand: 'पूर्व-स्वामित्व',
  machinePurchasePrice: 'खरीद मूल्य (₹)',
  machinePurchasePriceHint: 'इस मशीन के लिए आपने जो राशि चुकाई',
  machinePurchaseDate: 'खरीद तिथि',
  machineYearOfManufacture: 'निर्माण वर्ष',
  machineLoanSection: 'इस मशीन पर मेरा loan है',
  machineLoanAmount: 'Loan राशि (₹)',
  machineLoanEmi: 'मासिक EMI (₹)',
  machineLoanTenure: 'Loan अवधि (महीने)',
  machineLoanStartDate: 'Loan शुरू तिथि',
  machineFuelConsumption: 'ईंधन खपत (L/hr)',
  machineMonthlyOperatingExpenses: 'मासिक परिचालन व्यय',
  machineOperatorMonthlySalary: 'ऑपरेटर मासिक वेतन',
  machineServiceMonthly: 'सर्विस / रखरखाव (मासिक)',
  machineBreakdownMonthly: 'ब्रेकडाउन / मरम्मत (मासिक औसत)',
  machineMaterialsMonthly: 'सामग्री / उपभोग्य (मासिक)',
  recoveryPlan: 'रिकवरी प्लान',
  recoveryOnTrack: 'सही रास्ते पर',
  recoveryNeedsAttention: 'ध्यान दें',
  recoveryActionRequired: 'कार्रवाई जरूरी',
  recoveryAddPrice: 'रिकवरी प्लान देखने के लिए खरीद मूल्य जोड़ें',
  recoveryProgress: 'निवेश वसूली',
  recoveryDailyNet: 'रोजाना शुद्ध आय',
  recoveryDays: 'वसूली समय',
  recoveryProjectedDate: 'अनुमानित वसूली तारीख',
  recoveryRoi: 'सालाना रिटर्न',
  recoveryCurrentValue: 'वर्तमान मशीन मूल्य',
  editFinancialDetails: 'वित्तीय विवरण संपादित करें',
  financialDetailsSaved: 'वित्तीय विवरण सहेजे गए',
  recoveryBackfillNudge: 'रिकवरी ट्रैकिंग अनलॉक करने के लिए {{count}} मशीन(ों) में खरीद विवरण जोड़ें',
  dieselPriceTitle: 'डीजल की कीमत',
  dieselPriceUpdate: 'डीजल कीमत अपडेट करें',
  dieselPriceLatest: 'नवीनतम कीमत',
  dieselPriceNoRecord: 'कोई डीजल कीमत दर्ज नहीं',
  dieselPricePerLitre: 'प्रति लीटर कीमत (₹)',
  dieselQuantity: 'भरी गई मात्रा (लीटर)',
  dieselTaluka: 'शहर / क्षेत्र',
  bookingAttachment: 'अटैचमेंट चुनव',
  bookingAttachmentNone: 'कोनो खास अटैचमेंट नइं',
  bookingWorkDescription: 'काम के बिबरन',
  bookingWorkDescriptionPlaceholder: 'जइसे नींव खनना, ट्रेंचिंग, पाइपलाइन काम',
  bookingAttachmentLabel: 'अटैचमेंट',
  bookingSiteLabel: 'साइट',
  bookingWorkLabel: 'काम',
  termsAccept: "मैं नियम अउ शर्त मन से सहमत हंव",
  termsRequired: "पंजीयन बर नियम अउ शर्त स्वीकार करना जरूरी हे",
  termsLink: "नियम अउ शर्त",
  clientBlacklisted: "ब्लैकलिस्ट",
  clientBlacklistReason: "ब्लैकलिस्ट के कारण",
  clientBlacklistConfirm: "ए क्लाइंट ला ब्लैकलिस्ट करहू?",
  clientUnblacklist: "ब्लैकलिस्ट ले हटाव",
  blacklistedClients: "ब्लैकलिस्ट क्लाइंट",
  blacklistedClientsEmpty: "कोई ब्लैकलिस्ट क्लाइंट नइं",
  managerAccessRestricted: "वित्त पहुँच प्रतिबंधित। ओम चवान ले संपर्क करव।",
  managerSection: "मैनेजर",
  managerAdd: "मैनेजर जोड़व",
  managerName: "मैनेजर के नाम",
  managerEmail: "मैनेजर ईमेल",
  managerPassword: "अस्थाई पासवर्ड",
  managerCreated: "मैनेजर खाता बनिस",
  managerCredentialsTitle: "मैनेजर लॉगिन जानकारी",
  managerCredentialsSubtitle: "ये जानकारी अभी बचा के रखव — पासवर्ड बाद म नई मिलही",
  managerCredentialsSaved: "मैं जानकारी बचा ले रहेंव",
  managerLoginUrl: "लॉगिन URL",
  managerActivity: "मैनेजर गतिविधि",
  managerActivityEmpty: "अभी तक कोनो गतिविधि दर्ज नई हे",
  managerActivityViewAll: "सब गतिविधि देखव",
  onboardingTitle: "सुरू करव",
  onboardingAccountApproved: "खाता मंजूर",
  onboardingKycComplete: "KYC जांच पूरा",
  onboardingKycPending: "KYC जांच पूरा करव",
  onboardingKycRejected: "KYC खारिज — किरपा करके फेर जमा करव",
  onboardingWalletFunded: "वॉलेट मं रकम हे",
  onboardingWalletEmpty: "बुकिंग बर वॉलेट मं रकम जोड़व",
  pushEnablePrompt: "तुरंत अपडेट बर पुश सूचना चालू करव",
  downloadDisputeStatement: "विवाद बयान डाउनलोड करव",
  downloadInvoice: "इनवॉइस डाउनलोड करव",
  bookAgain: "फेर ले बुक करव",
  machineNoLongerAvailable: "मशीन अब उपलब्ध नइ हे",
  downloadHistoryPdf: "इतिहास PDF डाउनलोड करव",
  onboardingFirstBooking: "अपन पहिली बुकिंग करव",
  onboardingAllDone: "आप तैयार हव!",
  onboardingTrackerTitle: "ऑनबोर्डिंग प्रगति",
  onboardingTrackerTarget: "ऑनबोर्डिंग लक्ष्य: 48 घंटा",
  onboardingTrackerInProgress: "चलत हे",
  onboardingTrackerActionRequired: "कार्रवाई जरूरी",
  onboardingTrackerComplete: "पूरा",
  onboardingTrackerPending: "बाकी",
  onboardingTrackerPhase1: "पंजीकरण",
  onboardingTrackerPhase2: "KYC जांच",
  onboardingTrackerPhase3: "मशीन पंजीकरण",
  onboardingTrackerPhase4: "पहिली बुकिंग तैयार",
  onboardingTrackerHelper1: "मशीन पंजीकरण खोले बर आधार + सेल्फी अपलोड करव",
  onboardingTrackerHelper2: "KYC समीक्षा मं — आमतौर पर 24 घंटा मं",
  onboardingTrackerHelper3: "KYC खारिज — कागद फेर जमा करव",
  onboardingTrackerHelper4: "KYC मंजूर — अपन पहिली मशीन जोड़व",
  onboardingTrackerHelper5: "मशीन एडमिन समीक्षा मं",
  onboardingTrackerHelper6: "मशीन लाइव — पहिली बुकिंग के इंतजार",
  onboardingTrackerPhaseLabel: "चरण",
  alertsAndNotifications: 'अलर्ट अउ सूचना',
  dieselFuelCostPerHour: 'प्रति घंटा ईंधन लागत',
  dieselPercentOfRate: 'आपकी प्रति घंटा दर का',
  dieselPriceSaved: 'डीजल कीमत सहेजी गई',
  dieselRateSuggestion: 'दर सुझाव',
  dieselRateIncrease: 'डीजल बढ़ा — दर बढ़ाने पर विचार करें',
  dieselRateDecrease: 'डीजल घटा — बुकिंग के लिए दर कम करें',
  dieselSuggestedRate: 'सुझाई गई दर',
  dieselHistory: 'कीमत इतिहास',
  dieselNoHistory: 'अभी तक कोई डीजल कीमत इतिहास नहीं',
  dieselColDate: 'तारीख',
  dieselColPrice: 'कीमत/लीटर',
  dieselColQty: 'मात्रा',
  dieselColSource: 'स्रोत',
  dieselUploadReceipt: 'रसीद अपलोड करें',
  dieselExtractSuccess: 'रसीद से निकाला गया',
  dieselExtractFailed: 'निकाल नहीं सके — कृपया मैन्युअल दर्ज करें',
  applyRateSuggestion: '₹{{rate}}/घंटा लागू करें',
  rateSuggestionApplied: 'दर सफलतापूर्वक अपडेट हुई',
  marketPosition: 'बाजार स्थिति',
  marketBelowMarket: 'बाजार से नीचे',
  marketCompetitive: 'प्रतिस्पर्धी',
  marketAboveMarket: 'बाजार से ऊपर',
  marketNoData: 'आपके क्षेत्र के लिए अभी कोई बाजार डेटा नहीं',
  marketSubmitRate: 'बाजार दर जमा करें',
  marketCity: 'शहर / क्षेत्र',
  marketMinRate: 'आपके क्षेत्र की न्यूनतम दर (₹/घंटा)',
  marketMaxRate: 'आपके क्षेत्र की अधिकतम दर (₹/घंटा)',
  marketRateSubmitted: 'बाजार दर जमा हो गई — धन्यवाद!',
  marketDataPoints: '{{count}} जमा पर आधारित',
  marketRange: '{{city}} में बाजार',
  marketSourceLocal: '{{city}} क्षेत्र के दर मन पर आधारित',
  marketSourcePlatform: 'प्लेटफ़ॉर्म-व्यापी दर मन पर आधारित',
  regPremiumOnboarding: 'प्रीमियम ऑनबोर्डिंग',
  regRtoNumber: 'RTO पंजीकरण संख्या *',
  regSelectType: 'प्रकार चुनें…',
  regSubmitBtn: '✅ पंजीकरण जमा करें',
  regTagNoRto: 'RTO नहीं',
  regTagRto: 'RTO',
  regYearManufacture: 'निर्माण वर्ष *',
  register: 'मशीन पंजीकरण',
  registerAction: 'रजिस्टर करें',
  registerMachine: 'मशीन पंजीकरण',
  registering: 'रजिस्टर हो रहा है...',
  registrationPending: 'एडमिन 24 घंटे के भीतर आपका अकाउंट सक्रिय करेगा।',
  registrationSuccess: 'रजिस्ट्रेशन सफल!',
  remoteLockAlert: 'Teltonika GPS स्थापित होने के बाद रिमोट लॉक सक्षम होगा। DE सपोर्ट से संपर्क करें।',
  remoteLockMachine: '🔒 रिमोट लॉक मशीन',
  replaceFile: 'बदलें',
  reportText: 'रिपोर्ट',
  reports: 'रिपोर्ट',
  resetMethodEmail: 'Email link',
  resetMethodSms: 'SMS OTP',
  resetPasswordFailed: 'Could not reset password. Request a new link.',
  resetPasswordIntro: 'Choose a strong password with at least 8 characters.',
  resetPasswordMinLength: 'Password must be at least 8 characters.',
  resetPasswordMissingToken: 'Reset link is missing or invalid. Use Forgot password from login.',
  resetPasswordSubmit: 'Update password',
  resetPasswordSuccess: 'Password updated. Redirecting to login...',
  resetPasswordTitle: 'Set new password',
  resetPasswordUpdating: 'Updating...',
  resetText: 'रीसेट',
  retryDlqItemTitle: 'DLQ आइटम पुनः प्रयास',
  retryFailedForDlq: 'DLQ आइटम के लिए पुनः प्रयास विफल',
  retryReasonAuditPlaceholder: 'पुनः प्रयास का कारण (ऑडिट हेतु)',
  retryText: 'पुनः प्रयास',
  revenue: 'राजस्व',
  running: 'चालू',
  satisfiedNo: 'संतुष्ट नहीं',
  satisfiedYes: 'हाँ, संतुष्ट',
  save: 'सहेजें',
  scanToPay: 'भुगतान के लिए स्कैन करें',
  scheduleColFeedback: 'फीडबैक',
  scheduleColQty: 'Qty',
  scheduleColTotal: 'कुल',
  scheduleColType: 'प्रकार',
  securitySignalsTitle: 'सुरक्षा संकेत',
  selectBook: 'यह मशीन बुक करें →',
  selectCalc: '📋 चुनें और लागत देखें →',
  selectFile: 'फ़ाइल चुनें',
  selectMachineFirst: 'पहले मशीन चुनें',
  selectQty: 'मात्रा चुनें',
  selectRole: 'भूमिका चुनव',
  selectedMachineText: 'चयनित मशीन',
  send: 'भेजें',
  sendEmail: 'ईमेल भेजें',
  sendWhatsapp: 'WhatsApp पर भेजें',
  settlements: 'निपटान',
  show: 'दिखाएं',
  signIn: 'साइन इन',
  signingIn: 'लॉगिन हो रहल हे...',
  signupCompanyName: 'कंपनी का नाम',
  signupContactName: 'संपर्क नाम',
  signupCreatePassword: 'पासवर्ड बनाएं',
  signupReenterPassword: 'पासवर्ड दोबारा दर्ज करें',
  signupSectionCompany: 'कंपनी',
  signupSectionContact: 'आपका विवरण',
  signupSectionSecurity: 'सुरक्षा',
  sinceExcellence: '2011 से · 15 वर्ष उत्कृष्टता',
  sinceLabel: 'से',
  sloBreachRisk: 'SLO breach जोखिम',
  sloHealthy: 'SLO स्वस्थ',
  speed: 'गति',
  staleText: 'पुराना',
  status: 'स्थिति',
  statusCancelled: 'रद्द',
  bookingClosed: 'बंद',
  sectionNew: 'नवा',
  sectionAccepted: 'स्वीकृत',
  sectionActive: 'सक्रिय',
  sectionDispatched: 'डिस्पैच',
  sectionCompleting: 'पूरा होवत हे',
  sectionDisputed: 'विवादित',
  sectionCompleted: 'पूर्ण',
  sectionClosed: 'बंद',
  statusCompleted: 'पूर्ण',
  stopped: 'बंद',
  submit: 'जमा करें',
  submitOperatorFeedback: 'फीडबैक भेजें',
  submittedRegistrations: 'जमा पंजीकरण',
  support: 'सहायता',
  supportPolicyBooking: 'केवल वॉलेट अग्रिम। साइट पर नकद नहीं।',
  supportPolicyCancellation: '1 घंटे का जुर्माना; शेष वॉलेट में।',
  supportPolicyContact: 'केवल DE सपोर्ट — सीधा ऑपरेटर संपर्क वर्जित।',
  supportPolicyGst: 'सभी इनवॉइस पर 18% GST; रिपोर्ट टैब से डाउनलोड।',
  supportPolicyHours: 'सोम–शनि, 9–7 IST',
  tableAtt: 'उप',
  tableChange: 'बदलाव',
  tableDay: 'दिन',
  tableEnd: 'समाप्त',
  tableHrs: 'घं',
  tableId: 'आईडी',
  tableIn: 'इन',
  tableLevel: 'स्तर',
  tableMonth: 'महीना',
  tableNote: 'नोट',
  tableOut: 'आउट',
  tableStart: 'शुरू',
  tagline: 'बुनियादी ढांचा के सोने के मान',
  tax: 'कर',
  tdsGstTcs: 'TDS 2% + GST TCS 1%',
  tdsTcs: 'TDS+TCS',
  termCommission: 'Development Express कमीशन: सकल बिलिंग का 15%',
  termFuel: 'मशीन में हमेशा 40%+ ईंधन रखें',
  termGps: 'GPS (Teltonika) अनिवार्य — DE द्वारा स्थापित',
  termGstTcs: 'GST TCS: GST नियमों के अनुसार 1%',
  termNoDirectContact: 'सीधा क्लाइंट संपर्क = तत्काल अनुबंध समाप्ति',
  termPaymentDays: 'क्लाइंट निपटान के 3 कार्य दिवसों में भुगतान',
  termTds: 'TDS कटौती: आयकर अधिनियम के अनुसार 2%',
  threeWorkingDays: '3 कार्य दिवस',
  timeLabel: 'समय',
  todayText: 'आज',
  topSourceIp: 'शीर्ष स्रोत IP',
  total: 'कुल',
  totalAdvanceLabel: 'अग्रिम भुगतान',
  totalBookingsText: 'कुल बुकिंग',
  totalMachines: 'कुल मशीनें',
  totalSpent: 'कुल खर्च',
  tracking: 'GPS ट्रैकिंग',
  transactionHistoryTitle: 'लेनदेन इतिहास',
  transactions: 'लेनदेन इतिहास',
  trustStatCompliant: 'अनुपालन',
  trustStatMachines: 'मशीन',
  trustStatRating: 'रेटिंग',
  txnDescription: 'विवरण',
  type: 'प्रकार',
  understood: '✅ समझ गया — प्लेटफॉर्म उपयोग करूंगा',
  understoodAction: 'समझ गया',
  unknownText: 'अज्ञात',
  updateFuel: 'फ्यूल अपडेट करें',
  updateText: 'अपडेट करें',
  upiAppsHint: 'PhonePe | GPay | Paytm | BHIM',
  uploadFile: 'अपलोड',
  valEmail: 'वैध ईमेल आवश्यक',
  valMachineName: 'मशीन नाम / मॉडल आवश्यक',
  valMachineType: 'उपकरण श्रेणी चुनें',
  valMobility: 'व्हील्ड या क्रॉलर उपकरण प्रकार चुनें',
  valOwnerName: 'मालिक का नाम आवश्यक',
  valPdiChecks: 'सभी आवश्यक जांचें पुष्टि करें',
  valPdiRequired: 'PDI पुष्टि आवश्यक',
  valPhone: 'वैध फ़ोन नंबर आवश्यक',
  valRto: 'व्हील्ड मशीनों के लिए RTO नंबर आवश्यक',
  valUploadMissing: 'अपलोड करें: {docs}',
  valYear: 'वैध वर्ष (YYYY) आवश्यक',
  viewMachines: '→ मशीनें देखें',
  wallet: 'वॉलेट',
  walletBalance: 'वॉलेट बैलेंस',
  walletCredit: 'वॉलेट क्रेडिट',
  walletDebit: 'वॉलेट डेबिट',
  walletDeduct: '50% अग्रिम वॉलेट से · नकद नहीं · काम पूर्ण होने पर GST चालान',
  walletInsufficient: '❌ अपर्याप्त',
  walletLowRecharge: 'वॉलेट शेष कम — अगली बुकिंग से पहले रिचार्ज करें',
  walletOnly: 'खाली वॉलेट · नकद नइ स्वीकार',
  walletOnlyPolicyDesc: 'सभी लेनदेन केवल वॉलेट से। नकद स्वीकार नहीं।',
  walletOnlyPolicyTitle: 'केवल वॉलेट नीति',
  walletRechargeTitle: 'वॉलेट रिचार्ज',
  walletSufficient: '✅ आगे बढ़ें',
  weeks: 'सप्ताह',
  whatsapp: 'WhatsApp',
  wksUnit: 'सप्ताह',
  year: 'वर्ष',
  yearsExperience: '{n} वर्ष',
  yourMessage: 'अपना प्रश्न या समस्या लिखें...',
  // --- Recent feature strings ---
  retryLabel: 'फेर कोशिश करव',
  payrollPreview: 'पेरोल पूर्वावलोकन',
  payrollRun: 'पेरोल चलाएं',
  payrollAlreadyRun: 'इस महीने के लिए पेरोल पहले ही चल चुका है',
  payrollGross: 'कुल देय',
  payrollNet: 'शुद्ध देय',
  payrollAdvanceDeducted: 'अग्रिम कटौती',
  payrollRunSuccess: 'पेरोल सफलतापूर्वक चला',
  payrollNoAmount: 'इस महीने के लिए कोई देय राशि नहीं',
  payrollMonth: 'पेरोल महीना',
  exportPayrollCsv: 'पेरोल CSV निर्यात',
  payrollExportMonth: 'पेरोल निर्यात महीना',
  payrollDailyRate: 'दैनिक दर',
  payrollHistory: 'पेरोल इतिहास',
  payrollNoHistory: 'अभी तक कोई पेरोल नहीं चला',
  payrollColMonth: 'महीना',
  payrollColGross: 'कुल',
  payrollColDeduction: 'अग्रिम कटौती',
  payrollColNet: 'शुद्ध वेतन',
  payrollColDate: 'तारीख',
  downloadPayslip: 'पे स्लिप डाउनलोड',
  payslipTitle: 'मासिक पे स्लिप',
  payslipEarnings: 'आय',
  payslipDeductions: 'कटौती',
  payslipDaysWorked: 'कार्य दिवस',
  payslipGeneratedBy: 'Development Express द्वारा जनरेट',
  operatorPayrollTitle: 'मोर पगार',
  payrollMonthlySalary: 'मासिक पगार',
  payrollCurrentMonth: 'वर्तमान महीना',
  payrollPreviousMonth: 'पिछला महीना',
  ownerAttendanceTitle: 'हाजिरी',
  ownerAttendanceEdit: 'संपादन',
  ownerAttendanceSave: 'सेव',
  ownerAttendanceNoRecords: 'ए महीना ल हाजिरी रिकॉर्ड नइं',
  ownerAttendanceOverrideSuccess: 'हाजिरी अपडेट हो गे',
  ownerSalaryUpdated: 'वेतन सफलतापूर्वक अपडेट हो गे',
  ownerSalaryEditBtn: 'वेतन संपादन',
  ownerSalaryNotSet: 'वेतन सेट नइं — पेरोल ल वेतन सेट करो',
  duration: "अवधि",
  durationLabel: 'अवधि',
  plQuotaLabel: 'PL कोटा',
  plUsed: 'उपयोग',
  plAllowed: 'अनुमत',
  plRemaining: 'बाकी',
  plQuotaUpdated: 'PL कोटा अपडेट',
  plQuotaExhausted: 'PL कोटा समाप्त — बिन वेतन अवकाश के रूप में दर्ज',
  plRemainingLabel: 'शेष PL',
  noAttendanceRecords: 'अभी तक कोनो हाजिरी रिकॉर्ड नइंहे',
  noFuelLogs: 'अभी तक कोनो ईंधन लॉग नइंहे',
  noIssuesYet: 'अभी तक कोनो समस्या दर्ज नइंहे',
  failedToLoad: 'डेटा लोड करे में असफल',
  failedToLoadReport: 'रिपोर्ट लोड करे में असफल',
  failedToLoadIssues: 'समस्या लोड करे में असफल',
  failedToLoadAlerts: 'अलर्ट लोड करे में असफल',
  noRecordsMonth: 'ए महीना खातिर कोनो रिकॉर्ड नइंहे',
  underReview: 'समीक्षाधीन',
  issueResolved: 'हल हो गे',
  presentDaysLabel: 'हाजिरी दिन',
  halfDaysLabel: 'आधा दिन',
  absentDaysLabel: 'गैरहाजिरी दिन',
  totalHmrLabel: 'कुल HMR',
  noActiveBookingIdle: 'कोनो सक्रिय बुकिंग नइंहे — मशीन निष्क्रिय',
  siteLocationNotCaptured: 'साइट स्थान दर्ज नइंहे भे',
  siteLocationNotAvailable: 'साइट स्थान उपलब्ध नइंहे',
  bookingRefLabel: 'बुकिंग Ref',
  alertPendingBookings: 'लंबित बुकिंग',
  alertPendingPayouts: 'लंबित भुगतान',
  alertLowFuel: 'कम ईंधन',
  alertOpenIssues: 'खुली समस्या',
  noMachineRunning: 'अभी कोनो मशीन चालू नइंहे',
  trackingEmptyHint: 'मशीन भेजे के बाद अपन सक्रिय बुकिंग यहां दिखही।',
  trackingUpdatedEvery5s: 'हर 5 सेकंड में अपडेट',
  fuelLastOperatorUpdate: '(ऑपरेटर के अंतिम अपडेट)',
  alertExtensionPending: 'बुकिंग एक्सटेंशन लंबित',
  alertConfirmCompletion: 'कृपया काम पूर्णता के पुष्टि करव',
  alertWalletCredited: 'वॉलेट म जोड़े गे',
  alertFeedbackRequest: 'काम पूर्ण — अपन प्रतिक्रिया साझा करव',
  noLogsYet: 'अब तक कोई गतिविधि दर्ज नइ हे',
  todayActivityLog: 'आज के गतिविधि लॉग',
  machineLogSubtitle: 'ईंधन, हाजिरी, समस्या — स्थानीय सत्र लॉग',
  timerPaused: 'Timer रोक दे गे',
  liveBookingTitle: 'लाइव बुकिंग',
  machineLogTimerHint: 'Timer Admin शुरू करे हे। नीचे अपन असली काम के समय दर्ज करव — पूरा होए पर Mark Work Complete पर क्लिक करव।',
  resumeTimer: 'Resume Timer',
  pauseTimer: 'Pause Timer',
  attendanceLogNote: 'हाजिरी',
  ownerAlertBookingPending: 'नव बुकिंग अपन स्वीकृति खातिर लंबित —',
  ownerAlertBookingHours: 'घंटा',
  ownerAlertPayoutPending: '₹{{amount}} के भुगतान ट्रांसफर खातिर लंबित',
  ownerAlertFuelLow: 'ईंधन कम',
  ownerAlertFuelRemaining: 'बाकी',
  ownerAlertIssue: 'समस्या दर्ज',
  iotGpsDevicesActive: 'GPS उपकरण सक्रिय',
  iotDashcamsOnline: 'डैशकैम ऑनलाइन',
  iotFuelSensorsActive: 'ईंधन सेंसर सक्रिय',
  iotMachinesLocked: 'मशीन लॉक',
  iotDeviceStatus: 'IoT उपकरण स्थिति',
  iotColMachine: 'मशीन',
  iotColGps: 'GPS',
  iotColLocation: 'स्थान',
  iotColFuel: 'ईंधन %',
  iotColDashcam: 'डैशकैम',
  iotColIgnition: 'इग्निशन',
  iotColAction: 'कार्रवाई',
  iotStatusOnline: 'ऑनलाइन',
  iotStatusNotConnected: 'कनेक्ट नहीं',
  iotStatusLive: 'लाइव',
  iotStatusOn: 'ON',
  iotStatusOff: 'OFF',
  iotLockBtn: 'लॉक',
  iotNotConnectedBanner: 'IoT हार्डवेयर अभी स्थापित नहीं है। Teltonika उपकरण स्थापना के बाद GPS, डैशकैम और रिमोट लॉक सुविधाएं उपलब्ध होंगी।',
  fuelUpdateTitle: 'ईंधन अपडेट',
  fuelSensorAccuracyNote: 'ऑपरेटर द्वारा ईंधन स्तर दर्ज · मैन्युअल प्रविष्टि',
  bookingsTab: 'बुकिंग',
  unknownLabel: 'अज्ञात',
  naLabel: 'N/A',
  baseLabel: 'आधार',
  qtyLabel: 'मात्रा',
  actualHrsLabel: 'वास्तविक घंटे',
  auditStatTotal: 'कुल',
  auditStatSecurity: 'सुरक्षा',
  auditStatActors: 'कर्ता',
  auditStatAdmin: 'Admin',
  auditStatNonAdmin: 'गैर-Admin',
  kycDocLicense: 'लाइसेंस',
  kycDocAadhaarFront: 'Aadhaar सामने',
  kycDocAadhaarBack: 'Aadhaar पीछे',
  kycDocPoliceVerification: 'पुलिस सत्यापन',
  kycVerification: 'KYC जांच',
  kycNotSubmitted: 'KYC जमा नइहे',
  kycUnderReview: 'KYC समीक्षा म',
  kycVerified: 'KYC सत्यापित',
  kycRejected: 'KYC अस्वीकृत',
  kycAadhaarFront: 'Aadhaar आगे',
  kycAadhaarBack: 'Aadhaar पीछे',
  kycSelfie: 'सेल्फी',
  kycSubmitBtn: 'KYC दस्तावेज जमा कर',
  kycSubmitSuccess: 'दस्तावेज जमा — समीक्षा म',
  kycResubmit: 'दस्तावेज फेर जमा कर',
  adminKycTitle: 'क्लाइंट KYC समीक्षा',
  adminKycAllFilter: 'सब',
  adminKycNoSubmissions: 'अबहीं ले KYC जमा नइहे',
  adminOwnerKycTitle: 'मालिक KYC समीक्षा',
  adminOwnerKycNoSubmissions: 'अबहीं ले कोई मालिक KYC जमा नइहे',
  adminOperatorKycTitle: 'ऑपरेटर KYC समीक्षा',
  adminOperatorKycNoSubmissions: 'अबहीं ले कोई ऑपरेटर KYC जमा नइहे',
  kycRejectedWarning: 'तुम्हार KYC अस्वीकृत हो गे। कृपया दस्तावेज़ फेर जमा करो।',
  kycNotSubmittedHint: 'विश्वसनीय अनुभव खातिर KYC पूरा करो।',
  kycPendingHint: 'तुम्हार KYC समीक्षा में हे।',
  kycGoToTab: 'KYC पर जाओ',
  adminKycApproveBtn: 'मंजूर',
  adminKycRejectBtn: 'अस्वीकृत',
  adminKycViewDocs: 'दस्तावेज देख',
  adminKycRejectReason: 'अस्वीकृति के कारण',
  adminKycRereviewBtn: 'फेर समीक्षा',
  kycPan: 'PAN कार्ड',
  kycOwnerSubmitSuccess: 'दस्तावेज़ जमा — तुम्हार KYC समीक्षाधीन हे',
  kycLicense: 'ड्राइविंग लाइसेंस',
  kycPoliceVerification: 'पुलिस सत्यापन',
  kycOperatorSubmitSuccess: 'दस्तावेज़ जमा — तुम्हार KYC समीक्षाधीन हे',
  operatorKycRejectedAssign: 'ए ऑपरेटर के KYC अस्वीकृत हे — दोबारा स्वीकृत न होए तक उनने असाइन नहीं किया जा सकत।',
  operatorsColOperator: 'ऑपरेटर',
  operatorsColEmail: 'ईमेल',
  operatorsColPhone: 'फोन',
  operatorsColDocuments: 'दस्तावेज',
  operatorsColStatus: 'स्थिति',
  operatorsDocumentsBtn: 'दस्तावेज ({{count}})',
  operatorsNoResults: 'कोई ऑपरेटर ना मिले',
  operatorsAllTitle: 'सब ऑपरेटर ({{count}})',
  operatorsKycDialogDesc: 'KYC दस्तावेज',
  bookingsCountLabel: '{{count}} बुकिंग',
  complianceDates: 'अनुपालन तारीख',
  complianceInsurance: 'बीमा',
  complianceRcBook: 'RC बुक',
  compliancePuc: 'PUC',
  complianceNotSet: 'सेट नइ हे',
  complianceExpired: 'खतम',
  complianceExpiringSoon: 'जल्दी खतम',
  complianceExpiringCritical: '७ दिन म खतम',
  complianceValid: 'वैध',
  complianceUpdateBtn: 'अनुपालन तारीख अपडेट करव',
  complianceSaveBtn: 'सेव',
  complianceAlertsTitle: 'अनुपालन अलर्ट',
  complianceAllCompliant: 'सब मशीन अनुपालन म ✅',
  complianceColMachine: 'मशीन',
  complianceColOwner: 'मालिक',
  complianceColInsurance: 'बीमा',
  complianceColRcBook: 'RC बुक',
  complianceColPuc: 'PUC',
  complianceNa: 'N/A',
  complianceStartDate: 'शुरुआत तारीख',
  complianceEndDate: 'समाप्ति तारीख',
  complianceExtractBtn: 'तारीखां खुद भरने खातर दस्तावेज़ अपलोड करो',
  complianceExtractSuccess: 'तारीखां निकाल ली — सेव करण तै पहले जाँच ले',
  complianceExtractError: 'तारीखां निकाल नहीं सकी — खुद भरो',
  complianceExtracting: 'दस्तावेज़ पढ़ रया सै...',
  serviceHistory: 'सेवा इतिहास',
  serviceLastService: 'अंतिम सेवा',
  serviceNoRecords: 'अब तक कोनो सेवा रिकॉर्ड नइ हे',
  serviceNextDue: 'अगला सेवा देय',
  serviceNextHmr: 'अगला सेवा पर',
  serviceAddLog: 'सेवा लॉग जोड़',
  serviceDate: 'सेवा तारीख',
  serviceType: 'सेवा प्रकार',
  serviceHmr: 'सेवा HMR',
  serviceNextDate: 'अगला सेवा तारीख',
  serviceWorkDone: 'कइल काम',
  serviceNotes: 'नोट',
  serviceTypeRoutine: 'नियमित',
  serviceTypeMajor: 'प्रमुख',
  serviceTypeBreakdown: 'खराबी',
  serviceTypePdi: 'PDI',
  serviceTypeOther: 'अउ',
  serviceOverdue: 'अतिदेय',
  serviceDueSoon: 'जल्द देय',
  fleetAnalytics: 'फ्लीट एналिटिक्स',
  analyticsRevenue: 'कुल राजस्व',
  analyticsBookings: 'कुल बुकिंग',
  analyticsHours: 'कुल घंटे',
  analyticsActiveMachines: 'सक्रिय मशीन',
  analyticsMonthlyTrend: 'मासिक राजस्व रुझान',
  analyticsMachineTable: 'मशीन अनुसार राजस्व',
  analyticsNoData: 'इस अवधि में कोई पूर्ण बुकिंग नहीं',
  analyticsLastBooking: 'अंतिम बुकिंग',
  analytics3Months: '3 महीने',
  analytics6Months: '6 महीने',
  analytics12Months: '12 महीने',
  adminAnalytics: 'एनालिटिक्स',
  adminFleetTitle: 'फ्लीट एनालिटिक्स',
  adminFleetPlatformRevenue: 'प्लेटफ़ॉर्म राजस्व',
  adminFleetActiveOwners: 'सक्रिय मालिक',
  adminFleetOwnerCol: 'मालिक',
  adminFleetMonthlyTrend: 'मासिक राजस्व रुझान',
  adminFleetMachineTable: 'मशीन द्वारा राजस्व',
  adminFleetNoData: 'इस अवधि में कोई पूर्ण बुकिंग नहीं',
  adminFinancialIntelligence: 'मशीन वित्तीय जानकारी',
  adminTotalInvested: 'कुल निवेश',
  adminTotalEarned: 'कुल कमाई',
  adminAvgRecovery: 'औसत वसूली',
  adminBreakEvenRate: 'ब्रेक-ईवन दर',
  adminProfitMargin: 'लाभ मार्जिन',
  adminNoFinancialData: 'अभी तक वित्तीय डेटा वाली कोई मशीन नहीं',
  adminMachineDetail: 'मशीन विवरण',
  adminCallOwner: 'मालिक को कॉल करें',
  adminWhatsappOwner: 'WhatsApp मालिक',
  adminMarketRates: 'मार्केट रेट जमा',
  adminMarketRateDelete: 'हटाओ',
  adminMarketRateDeleteConfirm: 'का ए मार्केट रेट जमा हटाए?',
  adminMarketRateDeleted: 'मार्केट रेट हटा दिहे गे',
  adminMarketRateNoData: 'अब तक कोनो मार्केट रेट जमा नइ',
  marketRateApprove: 'मंजूर करव',
  marketRateReject: 'नामंजूर करव',
  marketRateApproved: 'मंजूर',
  marketRateRejected: 'नामंजूर',
  marketRatePending: 'लंबित',
  marketRateReviewed: 'मार्केट रेट के समीक्षा हो गे',
  marketRatePendingReview: 'आप मन के रेट जमा हो गे हे अउ एडमिन समीक्षा बर लंबित हे।',
  marketRateEditApprove: 'संपादित करव अउ मंजूर करव',
  marketRateEditMin: 'सही न्यूनतम रेट (₹/घंटा)',
  marketRateEditMax: 'सही अधिकतम रेट (₹/घंटा)',
  adminPayrollOverview: 'पेरोल अवलोकन',
  adminPayrollTotalOperators: 'कुल ऑपरेटर',
  adminPayrollTotalGross: 'कुल देय राशि',
  adminPayrollTotalNet: 'कुल शुद्ध देय',
  adminPayrollNoData: 'इस महीने के लिए कोई पेरोल डेटा नहीं',
  subTabSchedule: 'शेड्यूल',
  subTabHistory: 'इतिहास',
  subTabAnalytics: 'एनालिटिक्स',
  clientAnalyticsTitle: 'बुकिंग एनालिटिक्स',
  clientAnalyticsSpend: 'कुल खर्च',
  clientAnalyticsHours: 'कुल घंटे',
  clientAnalyticsBookings: 'पूर्ण बुकिंग',
  clientAnalyticsMachines: 'उपयोग की गई मशीनें',
  clientAnalyticsAvgSpend: 'प्रति बुकिंग औसत',
  clientAnalyticsMonthlyTrend: 'मासिक खर्च रुझान',
  clientAnalyticsTopMachines: 'शीर्ष मशीनें',
  clientAnalyticsNoData: 'इस अवधि में कोई पूर्ण बुकिंग नहीं',
  operatorAnalyticsTitle: 'कार्य विश्लेषण',
  operatorAnalyticsPresentDays: 'उपस्थित दिन',
  operatorAnalyticsHalfDays: 'आधा दिन',
  operatorAnalyticsHmr: 'कुल HMR',
  operatorAnalyticsJobs: 'पूर्ण कार्य',
  operatorAnalyticsIssues: 'रिपोर्ट किए गए मुद्दे',
  operatorAnalyticsAvgHmr: 'औसत HMR/दिन',
  operatorAnalyticsMonthlyTrend: 'मासिक कार्य रुझान',
  operatorAnalyticsIssueBreakdown: 'प्रकार के अनुसार मुद्दे',
  operatorAnalyticsRecentJobs: 'हाल के कार्य',
  operatorAnalyticsNoData: 'इस अवधि में कोई कार्य रिकॉर्ड नहीं',
  adminServiceAlertsTitle: 'सर्विस अलर्ट',
  adminServiceAllOk: 'सब मशीन के सर्विस रिकॉर्ड अप-टू-डेट हे ✅',
  adminServiceNoRecord: 'कोई रिकॉर्ड नइ',
  adminServiceColLastService: 'आखिरी सर्विस',
  adminServiceColNextDue: 'अगला Due',
  adminServiceColServiceStatus: 'सर्विस स्थिति',
  adminMachinesColMinHrs: 'कम से कम घंटा',
  adminMachinesColRateDay: 'दर/दिन',
  adminClientName: 'ग्राहक के नाम',
  adminOwnerName: 'मालिक के नाम',
  adminPayoutWallet: 'भुगतान वॉलेट',
  adminFooterMachines: 'मशीन',
  adminFooterClients: 'ग्राहक',
  adminFooterOwners: 'मालिक',
  auditSeverityCritical: 'गंभीर',
  auditSeverityHigh: 'उच्च',
  auditSeverityMedium: 'मध्यम',
  auditSeverityNormal: 'सामान्य',
  auditCopyEvent: 'इवेंट कॉपी करव',
  auditViewDetails: 'विवरण देखव',
  auditHideDetails: 'विवरण छुपाव',
  auditCopyJson: 'JSON कॉपी करव',
  auditNoLogs: 'कोनो ऑडिट लॉग नइ हे',
  auditIntroBanner: 'लॉगिन, एडमिन कार्रवाई अर सुरक्षा घटना। फिल्टर लोड किए गए परिणाम म लागू होथे; पुरान पंक्ति खातिर अउ लोड करव।',
  auditLoaded: 'लोड किए',
  auditMoreAvailable: 'अउ उपलब्ध',
  auditEndOfList: 'सूची समाप्त',
  auditFilterActive: 'फिल्टर सक्रिय',
  auditFiltersActive: 'फिल्टर सक्रिय',
  auditSeverityBreakdown: 'गंभीरता विभाजन (वर्तमान सूची)',
  auditPressSlash: 'कार्रवाई फिल्टर म फोकस करे खातिर / दबाव',
  auditFilters: 'फिल्टर',
  auditFilterActionPlaceholder: 'Filter action (e.g. dlq_retry)',
  auditFilterActorPlaceholder: 'Filter actorId',
  auditAllRoles: 'सब भूमिका',
  auditFilterEntityPlaceholder: 'Entity type (e.g. dead_letter_queue)',
  auditFilterMetaPlaceholder: 'मेटाडेटा JSON खोजव',
  auditFilterFromPlaceholder: 'शुरू तारीख अर समय',
  auditFilterToPlaceholder: 'अंत तारीख अर समय',
  audit24h: '24h',
  audit7d: '7d',
  auditTimezonePrefix: 'समय क्षेत्र:',
  auditTimezoneSuffix: '(स्थानीय)',
  auditHideCsvOptions: 'CSV कॉलम विकल्प छुपाव',
  auditShowCsvOptions: 'CSV कॉलम विकल्प देखाव',
  auditCsvColCreatedAt: 'निर्माण समय',
  auditCsvColAction: 'कार्रवाई',
  auditCsvColActorId: 'Actor ID',
  auditCsvColActorRole: 'Actor Role',
  auditCsvColEntityType: 'Entity Type',
  auditCsvColEntityId: 'Entity ID',
  auditCsvColMetadata: 'मेटाडेटा',
  auditFooterLoaded: 'लोड किए',
  auditFooterLogs: 'ऑडिट लॉग',
  auditFooterMoreAvailable: '(अउ उपलब्ध)',
  auditFooterAllLoaded: '(सब लोड किए)',
  auditActor: 'एक्टर',
  auditEntity: 'इकाई',
  auditEventLog: 'इवेंट लॉग',
  notificationCenter: 'सूचना',
  notifChannelAll: 'सब',
  notifChannelWhatsapp: 'WhatsApp',
  notifChannelEmail: 'ईमेल',
  notifChannelPush: 'पुश',
  notifChannelSms: 'SMS',
  notifStatusSent: 'भेजे गए',
  notifStatusFailed: 'असफल',
  notifStatusPending: 'लंबित',
  notifEmpty: 'अब तक कोई सूचना नइ',
  notifLoadMore: 'और लोड कर',
  adminNotifLog: 'सूचना लॉग',
  adminNotifColUser: 'उपयोगकर्ता',
  adminNotifColRole: 'भूमिका',
  adminNotifNoData: 'अब तक कोई सूचना लॉग नइ',
  etaOwnerApproval: 'मालिक मंजूरी के इंतजार',
  etaWorkInProgress: 'अनुमानित पूरा होए के समय',
  etaPaymentDeadline: 'भुगतान पुष्टि के अंतिम समय',
  etaWorkCompleted: 'काम पूरा',
  etaDisputeReview: 'DE टीम विवाद ke samiksha',
  etaMinutesRemaining: '{n} मिनट बाकी',
  etaHoursRemaining: '{n} घंटा बाकी',
  txRecharge: 'वॉलेट रिचार्ज',
  txBookingAdvance: 'बुकिंग अग्रिम',
  txBookingPayment: 'बुकिंग भुगतान',
  txSettlement: 'सेटलमेंट',
  txRefund: 'रिफंड',
  txPenalty: 'जुर्माना',
  txCommission: 'कमीशन',
  tacTitle: "नियम और शर्तें",
  tacPrivacy: "गोपनीयता नीति",
  tacRefund: "रिफंड नीति",
  tacCancellation: "रद्दीकरण नीति",
  tacServiceDelivery: "सेवा वितरण नीति",
  tacIntro: "बुकिंग से पहले हमारी नीतियाँ देखें",
  tacBannerTitle: "नियम अपडेट उपलब्ध",
  tacBannerOpen: "नियम खोलें",
  tacBannerAgree: "मैंने पढ़ लिया है और सहमत हूँ",
  tacBannerLater: "बाद में",
  clientPoliciesTitle: "ग्राहक नीतियाँ",
  machineGroupAvailable: "उपलब्ध",
  machineGroupBusy: "व्यस्त",
  dewateringReferral: "डीवाटरिंग (पंप) सेवा चाहिए? MachineOS जल्द पंप ठेकेदार सेवाएँ जोड़ेगा। रेफरल के लिए सपोर्ट से संपर्क करें।",
  noActiveWork: "इस महीने कोई सक्रिय कार्य नहीं",
  accountTab: "खाता",
  recentActivity: "हाल के काम",
  goodMorning: "सुप्रभात",
  goodAfternoon: "शुभ दोपहर",
  goodEvening: "शुभ संध्या",
  thisMonthEarned: 'This month earned',
  standardBookings: 'Standard bookings',
  activeContracts: 'Active contracts',
  contractsOngoing: 'Contracts ongoing',
  noActiveContracts: 'None this period',
  quotationsPending: 'Quotations awaiting reply',
  allUpToDate: 'All bookings up to date',
  noBookingsInPeriod: 'No bookings in this period',
  contractBookings: 'Contract bookings',
  noContractsInPeriod: 'No contracts in this period',
  mobilizationReleased: 'Mobilization released',
  pendingRelease: 'Pending release',
  raBills: 'RA-bills',
  disputed: 'Disputed',
  all: 'All',
  completed: 'Completed',
};
